import { render, staticRenderFns } from "./QuiltyResourceEditView.vue?vue&type=template&id=5b56f0f1&"
import script from "./QuiltyResourceEditView.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b56f0f1')) {
      api.createRecord('5b56f0f1', component.options)
    } else {
      api.reload('5b56f0f1', component.options)
    }
    module.hot.accept("./QuiltyResourceEditView.vue?vue&type=template&id=5b56f0f1&", function () {
      api.rerender('5b56f0f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/quiltyResources/QuiltyResourceEditView.vue"
export default component.exports